module.exports = {
  reCaptchaSiteKey: "6LfiKHQUAAAAACh_ZZn3aA2qnHUJh02SHGne06GZ",
  reCaptchaSecretKey: "6LfiKHQUAAAAAPEWdIptZk0v5PLnEWMS7xgDdbRh",
  apiUrl: "",
  hubSpotContactFormId: process.env.GATSBY_HABSPOT_CONTACT_FORM_ID || "baad0e6b-5b2c-48cf-b937-9019217b5a53",
  hubSpotEstimateFormId: process.env.GATSBY_HABSPOT_ESTIMATE_FORM_ID || "5bbf61e7-2fd5-4cf7-a68a-2abcda00f32d",
  hubSpotCookieName: "hubspotutk",
  mainUrl: process.env.GATSBY_FRONT_URL || 'http://localhost:8000',
}